/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Download_All_PendingInputs */

const en_doc_download_all_pending = /** @type {(inputs: Doc_Download_All_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloading…`)
};

const pt_br2_doc_download_all_pending = /** @type {(inputs: Doc_Download_All_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixando…`)
};

/**
* | output |
* | --- |
* | "Downloading…" |
*
* @param {Doc_Download_All_PendingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_download_all_pending = /** @type {((inputs?: Doc_Download_All_PendingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Download_All_PendingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_download_all_pending(inputs)
	return pt_br2_doc_download_all_pending(inputs)
});